/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
    GeoPointToJSONTyped,
} from './GeoPoint';
import type { DeliveryHandoffInstructions } from './DeliveryHandoffInstructions';
import {
    DeliveryHandoffInstructionsFromJSON,
    DeliveryHandoffInstructionsFromJSONTyped,
    DeliveryHandoffInstructionsToJSON,
    DeliveryHandoffInstructionsToJSONTyped,
} from './DeliveryHandoffInstructions';

/**
 * Represents the address book model.
 * @export
 * @interface AddressBook
 */
export interface AddressBook {
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    id: string;
    /**
     * 
     * @type {GeoPoint}
     * @memberof AddressBook
     */
    location?: GeoPoint;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    locality: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    administrativeArea: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    placeId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    deliveryInstructions?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressBook
     */
    isDefault?: boolean;
    /**
     * 
     * @type {DeliveryHandoffInstructions}
     * @memberof AddressBook
     */
    handoffInstructions?: DeliveryHandoffInstructions;
}



/**
 * Check if a given object implements the AddressBook interface.
 */
export function instanceOfAddressBook(value: object): value is AddressBook {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('locality' in value) || value['locality'] === undefined) return false;
    if (!('administrativeArea' in value) || value['administrativeArea'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function AddressBookFromJSON(json: any): AddressBook {
    return AddressBookFromJSONTyped(json, false);
}

export function AddressBookFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressBook {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'location': json['location'] == null ? undefined : GeoPointFromJSON(json['location']),
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'locality': json['locality'],
        'administrativeArea': json['administrativeArea'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'country': json['country'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'user': json['user'],
        'deliveryInstructions': json['deliveryInstructions'] == null ? undefined : json['deliveryInstructions'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'handoffInstructions': json['handoffInstructions'] == null ? undefined : DeliveryHandoffInstructionsFromJSON(json['handoffInstructions']),
    };
}

export function AddressBookToJSON(json: any): AddressBook {
    return AddressBookToJSONTyped(json, false);
}

export function AddressBookToJSONTyped(value?: AddressBook | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'location': GeoPointToJSON(value['location']),
        'line1': value['line1'],
        'line2': value['line2'],
        'locality': value['locality'],
        'administrativeArea': value['administrativeArea'],
        'postalCode': value['postalCode'],
        'country': value['country'],
        'placeId': value['placeId'],
        'user': value['user'],
        'deliveryInstructions': value['deliveryInstructions'],
        'isDefault': value['isDefault'],
        'handoffInstructions': DeliveryHandoffInstructionsToJSON(value['handoffInstructions']),
    };
}

